/*
 * @Author: your name
 * @Date: 2022-03-08 08:50:12
 * @LastEditors: onepisYa
 * @LastEditTime: 2022-03-26 14:30:58
 * @Description: file content
 */
import qs from "qs";
import request from "@/utils/request";

export function getPayChannels(params) {
  return request({
    url: "/account/pay/channels",
    method: "get",
    params,
  });
}
export function orderPay(data) {
  return request({
    url: "/trade/order-pay/pay",
    method: "post",
    data,
  });
}
// 店长发红包
export function redpackPay(data) {
  return request({
    url: "/product/redpack-pay/pay",
    method: "post",
    data,
  });
}
export function getBillInfo(id) {
  return request({
    url: "/account/pay/bill/" + id,
    method: "get",
  });
}
export function payPasswordExists() {
  return request({
    url: "/user/customer/exists/payPassword",
    method: "get",
  });
}
export function payByBalance(data) {
  return request({
    url: "/account/pay/via/balance",
    method: "post",
    data,
  });
}
export function payByWxH5(data) {
  return request({
    url: "/account/pay/via/wx/h5",
    method: "post",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    data: qs.stringify(data),
  });
}
export function payByWxJsapi(data) {
  return request({
    url: "/account/pay/via/wx/jsapi",
    method: "post",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    data: qs.stringify(data),
  });
}

export function payByAliH5(data) {
  return request({
    url: "/account/pay/via/ali/h5",
    method: "post",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    data: qs.stringify(data),
  });
}